import { faArrowDown, faArrowUp, faSort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export type GovernanceSortDirection = 'asc' | 'desc';

export function GovernanceSortableHeader({
  label,
  isActive,
  direction,
  onClick,
  className,
}: {
  label: string;
  isActive: boolean;
  direction: GovernanceSortDirection;
  onClick: () => void;
  className?: string;
}) {
  const icon = !isActive ? faSort : direction === 'asc' ? faArrowUp : faArrowDown;

  return (
    <button
      type="button"
      className={`group/sort -mx-1.5 inline-flex items-center gap-1.5 rounded-md bg-transparent px-1.5 py-0.5 uppercase tracking-[inherit] transition-colors hover:bg-slate-200/60 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
        isActive ? 'text-slate-900' : ''
      } ${className || ''}`}
      onClick={onClick}
    >
      {label}
      <FontAwesomeIcon
        icon={icon}
        className={`text-[0.625rem] transition-opacity ${isActive ? 'text-primary opacity-100' : 'text-slate-400 opacity-60 group-hover/sort:opacity-100'}`}
      />
    </button>
  );
}
